import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-informations-bien',
  templateUrl: './informations-bien.component.html',
  styleUrls: ['./informations-bien.component.scss'],
})
export class InformationsBienComponent {
  @Input() informationsBien!: Report.Property;
  @Input() isLoading = false;

  informationsBienInternal!: Report.Property;

  @Output() informationsBienChanged = new EventEmitter<Report.Property>();
  @Output() informationsBienEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onInformationsBienChanged(informationsBien: Report.Property): void {
    this.informationsBienInternal = informationsBien;
  }

  onSaveSection(): void {
    this.informationsBienChanged.emit(this.informationsBienInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.informationsBienEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
